class BbbMarquee extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.viewport = this.querySelector('.bbb-marquee__viewport');
    this.track = this.querySelector('.bbb-marquee__track');
    if (!this.viewport || !this.track) return;

    this.reduceClones();
    this.fillTrack();

    this._onResize = () => {
      this.fillTrack();
    };
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
  }

  reduceClones() {
    const groups = Array.from(this.track.querySelectorAll('.bbb-marquee__group'));
    if (groups.length < 1) return;
    this.source = groups[0];
    groups.slice(1).forEach((el) => el.remove());
  }

  fillTrack() {
    if (!this.source) return;

    while (this.track.children.length > 1) {
      this.track.lastElementChild.remove();
    }

    const target = Math.max(this.viewport.offsetWidth * 2, this.source.offsetWidth * 2) + 40;
    while (this.track.scrollWidth < target) {
      this.track.appendChild(this.source.cloneNode(true));
    }
    if (this.track.children.length % 2 === 1) {
      this.track.appendChild(this.source.cloneNode(true));
    }

    const halfWidth = this.track.scrollWidth / 2;

    if (!halfWidth && !this._retriedLayout) {
      this._retriedLayout = true;
      requestAnimationFrame(() => {
        this.fillTrack();
      });
      return;
    }

    if (halfWidth) {
      this.style.setProperty('--bbb-marquee-duration', `${halfWidth / 75}s`);
    }
  }
}

customElements.define('bbb-marquee', BbbMarquee);
